import { useEffect, useState } from 'react';

import DeleteButton from '../../elements/DeleteButton';
import EditButton from '../../elements/EditButton';
import ViewButton from '../../elements/ViewButton';
import Paginator from '../../elements/paginator';
import axios from '../../services/MyAxios';
import {PERMISSION} from "../../helpers/Permissions";

function PaymentMethodChannelList() {
    const [paymentMethodChannels, setPaymentMethodChannels] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const url = '/crea/api/payment_method_channel';

    function getPaymentMethodChannels(page = 1) {
        axios.get(`${url}?page=${page}`).then((response) => {
            setPaymentMethodChannels(response.data.data);
            setCurrentPage(response.data.current_page);
            setLastPage(response.data.last_page);
        });
    }

    useEffect(() => {
        getPaymentMethodChannels();
    }, []);

    function getMappedData() {
        return paymentMethodChannels.map(({ id, payment_method_name, name, logo_url, order, created_at }) => (
            <tr key={id}>
                <td>{id}</td>
                <td>{payment_method_name}</td>
                <td>{name}</td>
                <td>
                    <img className="img payment-method-channel" src={logo_url} />
                </td>
                <td>{order}</td>
                <td>{created_at}</td>
                <td>
                    <ViewButton
                        url={`/payment_method_channels/${id}`}
                        permissions={[PERMISSION.VIEW_PAYMENT_METHOD_CHANNEL]}
                        key="view"
                    />
                    <EditButton
                        url={`/payment_method_channels/${id}/edit`}
                        permissions={[PERMISSION.UPDATE_PAYMENT_METHOD_CHANNEL]}
                        key="edit"
                    />
                    <DeleteButton
                        url={`/crea/api/payment_method_channel/${id}`}
                        action={() => getPaymentMethodChannels(currentPage)}
                        permissions={[PERMISSION.DELETE_PAYMENT_METHOD_CHANNEL]}
                        key="delete"
                    />
                </td>
            </tr>
        ));
    }

    return (
        <div className="card">
            <table className="table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Payment Method</th>
                        <th>Name</th>
                        <th>Logo</th>
                        <th>Order</th>
                        <th>Created at</th>
                        <th />
                    </tr>
                </thead>
                <tbody>{getMappedData()}</tbody>
            </table>

            <Paginator currentPage={currentPage} lastPage={lastPage} onPageChange={getPaymentMethodChannels} />
        </div>
    );
}

export default PaymentMethodChannelList;
